<template>
  <div class="pagamento-fallito">
    <div class="error-card">
      <div class="error-icon">✕</div>
      <h1>Pagamento Non Completato</h1>
      <p class="error-message">
        Il pagamento non è andato a buon fine o è stato annullato.
      </p>
      
      <p class="info-text">
        Il tuo ordine non è stato addebitato. Puoi riprovare o contattarci per assistenza.
      </p>

      <div class="buttons">
        <button class="btn-retry" @click="retry">Riprova</button>
        <button class="btn-home" @click="goHome">Torna alla Home</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PagamentoFallito',
  methods: {
    retry() {
      this.$router.push({ name: 'OrdineAsporto' })
    },
    goHome() {
      this.$router.push({ name: 'Benvenuto' })
    }
  }
}
</script>

<style scoped>
.pagamento-fallito {
  min-height: 100vh;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.error-card {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 40px;
  max-width: 500px;
  width: 100%;
  text-align: center;
  color: white;
}

.error-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #ff4444, #ff6b6b);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  margin: 0 auto 20px;
  color: white;
}

h1 {
  color: #ff6b6b;
  margin-bottom: 10px;
}

.error-message {
  color: #aaa;
  font-size: 1.1rem;
  margin-bottom: 20px;
}

.info-text {
  color: #888;
  font-size: 0.95rem;
  margin-bottom: 30px;
}

.buttons {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.btn-retry {
  background: linear-gradient(90deg, #ff6b6b, #ffa500);
  border: none;
  padding: 14px 40px;
  border-radius: 8px;
  color: white;
  font-size: 1.1rem;
  font-weight: bold;
  cursor: pointer;
  transition: transform 0.2s;
}

.btn-retry:hover {
  transform: translateY(-2px);
}

.btn-home {
  background: transparent;
  border: 1px solid #666;
  padding: 14px 40px;
  border-radius: 8px;
  color: #aaa;
  font-size: 1rem;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s;
}

.btn-home:hover {
  border-color: #aaa;
  color: white;
}
</style>
